var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 2.5293,
    width: 23,
    height: 18.9415,
    rx: 2,
    fill: "#E4E4E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.5293C0.5 3.42473 1.39543 2.5293 2.5 2.5293H21.4984C22.603 2.5293 23.4984 3.42473 23.4984 4.5293H0.5Z",
    fill: "#E94235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.76465H23.4984V8.76465H0.5V6.76465Z",
    fill: "#E94235"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 11H23.4984V13H0.5V11Z",
    fill: "#E94235"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 15.2354H23.4984V17.2354H0.5V15.2354Z",
    fill: "#E94235"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 19.4707H23.4984C23.4984 20.5753 22.603 21.4707 21.4984 21.4707H2.5C1.39543 21.4707 0.5 20.5753 0.5 19.4707Z",
    fill: "#E94235"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.3293C0.5 3.33518 1.30589 2.5293 2.3 2.5293H12V12H0.5V4.3293Z",
    fill: "#475993"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/US.4f78e77121504ce7ae5370fab1a5fa72.svg";
export { ForwardRef as ReactComponent };